 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import TEXTTITLE from '@/components/text/Title'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXTINTRODUCTION from '@/components/text/Introduction'
 import TEXTCHAPTER001 from '@/components/text/Chapter001'
 import TEXTCHAPTER002 from '@/components/text/Chapter002'
 import TEXTCHAPTER003 from '@/components/text/Chapter003'
 import TEXTCHAPTER004 from '@/components/text/Chapter004'
 import TEXTCHAPTER005 from '@/components/text/Chapter005'
 import TEXTCHAPTER006 from '@/components/text/Chapter006'
 import TEXTCHAPTER007 from '@/components/text/Chapter007'
 import TEXTCHAPTER008 from '@/components/text/Chapter008'
 import TEXTCHAPTER009 from '@/components/text/Chapter009'
 import TEXTCHAPTER010 from '@/components/text/Chapter010'
 import TEXTCHAPTER011 from '@/components/text/Chapter011'
 import TEXTNOTES from '@/components/text/Notes'
 import TEXTACKNOWLEDGMENTS from '@/components/text/Acknowledgments'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
 import TEXTALSO_BY from '@/components/text/Also_By'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/Introduction",
 			"name" : "text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/text/Chapter001",
 			"name" : "text/Chapter001",
 			"component" : TEXTCHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js